
export const icon ={
    maxWidth:32,
    maxHeight:32
}